import React, { useEffect, useState } from "react";
import LessonEdit from "./LessonEdit";
import LessonDataCarta from "./LessonDataCarta";
import { useLessonDetails } from "../../../hooks/useLessonDetails";

const LessonMiddleware = ({ ...props }) => {
  const lessonId = props.lessonId;
  const lesson = useLessonDetails(lessonId);
  const [lessonType, setLessonType] = useState("");

  //   console.log(`lessonId: ${lessonId}`);

  useEffect(() => {
    setLessonType(Object.keys(lesson?.data || {})[0] || lesson?.type);
  }, [lesson]);

  if (lessonType === "LESSON_CARTA")
    return <LessonDataCarta onChange={props.onChange} data={lesson} />;
  else
    return (
      <LessonEdit
        {...props}
        onCardClick={(lessonType) => {
          setLessonType(lessonType);
        }}
      />
    );
};

export default LessonMiddleware;
